import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { Button, Collapse, theme } from 'antd';
import { observer } from 'mobx-react-lite';
import { useRouter } from 'next/router';
import RightSideApp from '../../components/plugins/RightSideApp';
import { tabTypeMap } from '../../model/types';
import { useTabStore } from '../../store/RootStoreContext';
import { getSelectedTabKeyFromUrl } from '../../store/childStore/tabStore';
import { SIDEBAR_PLUGIN_WIDTH, TAB_BAR_HEIGHT, TICKET_FOOTER_HEIGHT } from '../../styles/theme';
import { getPluginStore } from '../../utils/store/getStore';

const { Panel } = Collapse;

interface SidebarContentProps extends Props {
    isVisible: boolean;
    tabKey: string;
}

function SideBarContent({ isOpen, isVisible, onButtonClick, tabKey }: SidebarContentProps) {
    const {
        token: { colorSplit, lineWidth, motionDurationSlow }
    } = theme.useToken();
    return (
        <>
            <Button
                className="side-bar-plugin-toggle-button"
                type="primary"
                size="large"
                onClick={() => onButtonClick()}
                icon={isOpen ? <MenuFoldOutlined /> : <MenuUnfoldOutlined />}
                style={{
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                    position: 'fixed',
                    right: isOpen ? SIDEBAR_PLUGIN_WIDTH : 0,
                    top: TAB_BAR_HEIGHT + 35,
                    transition: `all ${motionDurationSlow}`,
                    visibility: isVisible ? 'visible' : 'hidden',
                    zIndex: 1
                }}
            />
            <div
                className="side-bar-plugin-content"
                style={{
                    borderInlineStart: `${lineWidth}px solid ${colorSplit}`,
                    height: `calc(100vh - ${TAB_BAR_HEIGHT}px - ${TICKET_FOOTER_HEIGHT}px)`,
                    position: 'fixed',
                    right: 0,
                    top: TAB_BAR_HEIGHT,
                    transition: `all ${motionDurationSlow}`,
                    visibility: isVisible ? 'visible' : 'hidden',
                    width: isOpen ? SIDEBAR_PLUGIN_WIDTH : 0
                }}
            >
                {tabKey}
                <Collapse
                    defaultActiveKey={getPluginStore()
                        .getRightPanelPlugins()
                        .map((pd) => pd.pluginId)}
                >
                    {getPluginStore()
                        .getRightPanelPlugins()
                        .map((pd) => (
                            <Panel forceRender={true} header={pd.manifest.title ?? pd.pluginId} key={pd.pluginId}>
                                <RightSideApp pluginDefinition={pd} key={pd.pluginId} />
                            </Panel>
                        ))}
                </Collapse>
            </div>
        </>
    );
}

interface Props {
    isOpen: boolean;
    onButtonClick: () => void;
}

function SidebarPluginContainer(props: Props) {
    const { tabs } = useTabStore();
    const { asPath } = useRouter();
    const selectedTabKey = getSelectedTabKeyFromUrl(asPath);

    return (
        <>
            {tabs
                .filter((tab) => tab.type === tabTypeMap.TICKET)
                .map((tab) => (
                    <SideBarContent key={tab.key} isVisible={selectedTabKey === tab.key} tabKey={tab.key} {...props} />
                ))}
        </>
    );
}

export default observer(SidebarPluginContainer);
